interface UnpostedBatchToastBodyProps {
    reason: string
    productDescription: string
    validity: string
    quantity: number
    batchId: number
}

export const UnpostedBatchToastBody = ({
  reason, productDescription, validity, quantity, batchId,
}: UnpostedBatchToastBodyProps) => (
  <div>
    <div><b>{reason}</b></div>
    <br />
    <div>{productDescription}</div>
    <div><b>Validade:</b> {validity}</div>
    <div><b>Qtd.:</b> {quantity}</div>
    <div><b>Lote:</b> {batchId}</div>
  </div>
)
